<mat-form-field
  class="ui-chips-autocomplete-field ui-form-field-v2"
  appearance="outline"
  [subscriptSizing]="description ? 'dynamic' : 'fixed'"
  (focusout)="onFocusOut()"
>
  @if (label) {
    <mat-label>{{ label }}</mat-label>
  }
  <mat-chip-grid
    #chipGrid
    [disabled]="disabled || control.disabled"
    [errorStateMatcher]="errorStateMatcher"
    [required]="required"
  >
    @for (item of control.value; track item?.id ?? item) {
      <mat-chip-row [value]="item.id" (removed)="remove(item)">
        <span class="chip-text">{{ returnWholeObject ? item.name : optionNamesMap[item] }}</span>
        <button matChipRemove>
          <mat-icon class="ui-form-field__icon">cancel</mat-icon>
        </button>
      </mat-chip-row>
    }
    <input
      [placeholder]="
        hasSelectedItems
          ? ''
          : ((addNewValueOnBlur || addNewValueOnEnter
              ? 'newItemPlaceholder'
              : 'pleaseStartTypingToFilter'
            ) | translate)
      "
      #inputField
      [formControl]="inputControl"
      [required]="required"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipGrid"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (matChipInputTokenEnd)="onInputTokenEnd($event)"
    />
  </mat-chip-grid>
  @if (showErrorIcon) {
    <span matIconSuffix class="ui-form-field__status-icon" aria-hidden="true">
      <mat-icon class="ui-form-field__icon">error_outline</mat-icon>
    </span>
  }
  @if (description) {
    <mat-hint>{{ description }}</mat-hint>
  }
  @let errorText = control.errors | joinErrorMessages: messages;
  <mat-error [attr.title]="errorText">{{ errorText }}</mat-error>
  <mat-autocomplete
    #auto="matAutocomplete"
    class="app-ui-select"
    (optionSelected)="onSelect($event)"
    (opened)="control.markAsTouched()"
  >
    @for (option of filteredOptions; track option.id) {
      <mat-option [value]="returnWholeObject ? option : option.id">
        {{ option.name }}
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
